export interface IWindow {
  Header?: IWindowHeader;
  Footer?: IWindowFooter;
  Position: 'zero'        | 'top start'    | 'top center'| 'top end'   |
            'left start'  | 'left center'  | 'left end'  |
            'right start' | 'right center' | 'right end' |
            'center'      | 'center byMenu'| 'favorite'  | 'favorite-rs' | 'miniWindow'
  PositionMini: '' | 'left' | 'right';
  isMinimized?: boolean;
  VisibleMini: boolean;
  PanelClass?: string;
}

export interface IWindowHeader {
  Visible?: boolean;
  Title?: string;
  VisibleTitle?: boolean;
  Icon?: string;
  Maximized?: boolean;
}

export interface IWindowFooter {
  Visible?: boolean;
  ShowOk?: boolean;
  ShowCancel?: boolean;
  ShowEdit?: boolean;
}


export enum WindowActions {
  Close = 'Close',
  Minimize = 'Minimize',
  Maximize = 'Maximize',
  Ok = 'Ok',
  Edit = 'Edit',
  Cancel = 'Cancel',
  MaximizedMobile = 'MaximizedMobile',
  MinimizedMobile = 'MinimizedMobile'

}

export interface IWindowActions {
  Action: WindowActions;
  Event?: any;
  [Key: string]: any;
}
